import React from 'react';
import Slider from 'react-slick';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Dynamic import for all 39 photos from 2025 (photo1.jpeg through photo39.jpeg)
const photos = Array.from({ length: 39 }, (_, i) => 
  require(`../assets/2025photos/photo${i + 1}.webp`)
);

// Data for Video Cards
const videoData = [
  {
    name: "Justin Zeises from Fast Athletics",
    websiteLink: "https://www.fastathleticskills.com/",
    instagramHandles: ["@fastathleticskills"],
    youtubeId: "UcO1Lhrqbk8" 
  },
  {
    name: "Rob Ziegelbaum from Ziegelbaum Physical Therapy",
    websiteLink: "https://www.zz-pt.com/",
    instagramHandles: ["@zr_ziegelbaumpt"],
    youtubeId: "0Y77BkCEhbo"
  },
  {
    name: "Ofir Solomon from Sportime Port Washington",
    websiteLink: "https://www.sportimeny.com/portwashington",
    instagramHandles: ["@_ofirsolomon", "@sportimeportwashington"],
    youtubeId: "xSuaYQg8SZY"
  },
  {
    name: "Rachel Berman, RD",
    websiteLink: "https://www.rachelberman.com/",
    instagramHandles: [],
    youtubeId: "lsqI-ntfuWY" 
  },
  {
    name: "Ashley Marcus from The Studio",
    websiteLink: "https://www.thestudiopw.com/",
    instagramHandles: ["@thestudio_pw", "@ashimusi"],
    youtubeId: "8TLXFYGVvVg"
  }
];

const getInstagramUrl = (handle) => {
    return handle ? `https://www.instagram.com/${handle.replace('@', '')}/` : null;
};

// --- Video Card Component ---
const VideoCard = ({ name, websiteLink, instagramHandles, youtubeId }) => {
    const hasWebsite = !!websiteLink;
    const instagramUrls = instagramHandles.map(getInstagramUrl).filter(url => url !== null);

    const renderSocialLinks = () => {
        const links = [];
        
        if (hasWebsite) {
            links.push(
                <a key="website" href={websiteLink} target="_blank" rel="noopener noreferrer">Website</a>
            );
        }

        instagramUrls.forEach((url, index) => {
            const handle = instagramHandles[index];
            links.push(
                <a key={`insta-${index}`} href={url} target="_blank" rel="noopener noreferrer">Instagram: {handle}</a>
            );
        });

        if (links.length === 0) return null;

        return (
            <p style={{ margin: 0, fontSize: '0.9rem', color: '#666', display: 'flex', gap: '5px', justifyContent: 'center' }}>
                {links.map((link, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && <span>|</span>}
                        {link}
                    </React.Fragment>
                ))}
            </p>
        );
    };

    const videoContent = youtubeId ? (
        <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title={`${name} YouTube Video`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy" // <--- Lazy load YouTube embeds so they don't block image loads
            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '6px' }}
        ></iframe>
    ) : (
        `Video Placeholder for: ${name}`
    );

    return (
        <div className="video-card">
            <div className="video-placeholder">
                {videoContent}
            </div>
            
            <h3 style={{ margin: '10px 0 5px 0' }}>{name}</h3>
            {renderSocialLinks()}
        </div>
    );
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", zIndex: 1 }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", zIndex: 1 }}
      onClick={onClick}
    />
  );
}

const MediaPage = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    arrows: true,
    dots: false,
    swipe: true,
    lazyLoad: 'progressive', // <--- React-Slick only loads upcoming slide images
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  return (
    <div className="videos-container">
      <h2>Photos from 2025</h2>
      <div className="carousel-container" style={{ marginBottom: '60px', position: 'relative' }}>
        <Slider {...settings}>
          {photos.map((src, idx) => (
            <div 
              key={idx}
              style={{
                width: '100%',
                aspectRatio: '1 / 1',
                maxHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img
                src={src}
                alt={`Event 2025 ${idx + 1}`}
                loading={idx === 0 ? "eager" : "lazy"} // <--- First photo loads immediately, rest lazy load
                decoding="async"
                style={{
                  width: '100%',
                  aspectRatio: '1 / 1',
                  maxHeight: '400px',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      <h2 style={{marginTop: '40px'}}>Event Videos</h2>
      <div className="video-stack-container" style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
        {videoData.map((video, index) => (
            <VideoCard 
                key={index}
                name={video.name}
                websiteLink={video.websiteLink}
                instagramHandles={video.instagramHandles}
                youtubeId={video.youtubeId}
            />
        ))}
      </div>
    </div>
  );
};

export default MediaPage;